import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import NProgress from 'vue-nprogress'
import axios from 'axios'
import Toast from 'vue-toastification'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import '@/filters/index'
import { setAuthHeaderFromStore } from '@/utils/auth-utils'

import 'vue-toastification/dist/index.css'

Vue.config.productionTip = false

Vue.use(NProgress)
Vue.use(Toast)

const nprogress = new NProgress()

// Set the authorization header based on the persisted state
setAuthHeaderFromStore(store)
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

new Vue({
  router,
  store,
  vuetify,
  nprogress,
  render: h => h(App),
}).$mount('#app')
